import React from 'react';

import styled from "styled-components";
import IconAlert from "../ui/components/icons/legacy/alert";
const StyledErrorIconAlert = styled(IconAlert)`
    display: inline-block !important;
    vertical-align: top;
    margin-right: 10px;
`;

const StyledErrorDiv = styled.div`
    display: block;
    padding: 0px;
    margin: 0px 0px 10px 0px;
    text-align: center;
`;

const StyledErrorLabel = styled.div`
    display: inline-block;
    margin-top: 3px;
    font-family: Inter,Verdana,Arial,sans-serif;
    font-size: 0.80rem;
    color: #a50000;
    line-height: 20.0px;
    vertical-align: top;
`;


const ErrorMessage= (props) => {
    return (
        <StyledErrorDiv>
            <StyledErrorIconAlert color="error" size={24}/>
            <StyledErrorLabel> {props.children} </StyledErrorLabel>
        </StyledErrorDiv>
    );
}

export default ErrorMessage;
